import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { GoogleAuthProvider } from './core/auth/GoogleAuthProvider'
import { initializeTheme } from './core/theme/themeStore'
import { ToastProvider } from './shared/components/ui/Toast'
import { GlobalErrorDialog } from './shared/components/ui/GlobalErrorDialog'

/**
 * 애플리케이션 진입점
 *
 * React 19의 StrictMode로 감싸서 개발 모드에서
 * 잠재적 문제를 조기에 발견합니다.
 *
 * GoogleAuthProvider로 Google OAuth 인증을 제공합니다.
 */

// 테마 초기화 (React 렌더링 전에 실행)
// localStorage에 저장된 테마를 즉시 적용하여 깜빡임을 방지합니다.
initializeTheme()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <GoogleAuthProvider>
      <ToastProvider>
        <App />
        {/*
          App 안이 아니라 형제로 두는 이유: App은 로딩·로그인·온보딩 단계에서
          서로 다른 화면을 early return 한다. 그 안에 두면 어느 단계에서는
          에러 모달이 아예 마운트되지 않아, 정작 초기화 실패를 못 보여준다.
        */}
        <GlobalErrorDialog />
      </ToastProvider>
    </GoogleAuthProvider>
  </StrictMode>
)
